import { alpha } from "@mui/system";

const styles = (theme) => ({
  containerComponent: {
    p: 3,
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  containerTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 1,
  },
  boxColor: {
    p: 2,
    borderRadius: "16px",
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
  },
  boxAuto: {
    p: 2,
    maxHeight: 200,
    overflowY: "auto",
  },
  boxItens: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
  },
  paper: {
    p: 2,
    borderRadius: 2,
  },
  boxComments: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
});

export default styles;
